module.exports = __webpack_public_path__ + "static/media/speech_15.426ae620.svg";